import { Controller } from "@hotwired/stimulus"

// Colapsa/expande grupos de filas dentro de una tabla: el trigger (fila
// resumen) y su panel (tbody de detalle, inicialmente hidden) comparten
// data-group. El chevron rota 90 grados al expandir; viene renderizado
// server-side porque FontAwesome en modo SVG+JS no convierte <i> creados
// dinamicamente en JS.
export default class extends Controller {
  static targets = ["panel", "chevron"]

  toggle(event) {
    const group = event.currentTarget.dataset.group
    const panel = this.panelTargets.find((el) => el.dataset.group === group)
    if (!panel) return

    const hidden = panel.classList.toggle("hidden")

    const chevron = this.chevronTargets.find((el) => el.dataset.group === group)
    if (chevron) chevron.style.transform = hidden ? "" : "rotate(90deg)"
  }
}
